/**
 * HalfCirclePercent
 * 
 * @Author: Focci
 * @Date: 2024-12-18 15:19:10
 * @Last Modified by: Focci
 * @Last Modified time: 2024-12-18 15:19:10
 */

'use client'

import { useCallback, useEffect, useRef } from 'react'

export default function HalfCirclePercent({
  value = 50,
  color = '#20a4f8',
  bgColor = '#ddd',
  strokeWidth = 10
}) {
  const ele = useRef()

  const updateProgress = useCallback((progress) => {
    // 确保 progress 在 0 到 100 之间
    progress = Math.max(0, Math.min(100, progress))
    
    // 计算前景圆弧的长度
    const circumference = 283
    const offset = (1 - progress / 100) * circumference

    ele.current.setAttribute('stroke-dasharray', `${circumference - offset} ${offset}`)
  }, [])

  useEffect(() => { updateProgress(value) }, [updateProgress, value])

  return (
    <svg width="100" height="50" viewBox="0 0 200 100">
      <path 
        d="M 10 100 A 90 90 0 0 1 190 100" 
        fill="none" 
        stroke={bgColor} 
        strokeWidth={strokeWidth}
      />
      <path
        ref={ele}
        d="M 10 100 A 90 90 0 0 1 190 100"
        fill="none" 
        stroke={color}
        strokeWidth={strokeWidth}
        strokeDasharray="0 283" 
        strokeLinecap="round" 
      />
    </svg>
  )
}
